import { Reducer } from 'redux';
import { types } from './AuditActions';
import { IAuditState, IAuditAction } from '../../common/model/AuditModels';

export const auditReducer: Reducer<IAuditState, IAuditAction> = (
    state: IAuditState = { activities: null },
    action: IAuditAction
) => {
    switch (action.type) {
        case types.LIST_ACTIVITIES_REQUEST:
            return {
                ...state,
                loadingActivities: true,
                activitiesError: null,
            };

        case types.LIST_ACTIVITIES_SUCCESS:
            return {
                ...state,
                loadingActivities: false,
                activities: action.payload,
            };

        case types.NEW_ACTIVITIES_SUCCESS:
            return {
                ...state,
                loadingActivities: false,
                activities: {
                    ...state.activities,
                    items: [action.payload, ...state.activities.items],
                },
            };

        case types.LIST_MORE_ACTIVITIES_SUCCESS:
            return {
                ...state,
                loadingActivities: false,
                activities: {
                    ...state.activities,
                    items: [...state.activities.items, ...action.payload.items],
                },
            };

        case types.LIST_ACTIVITIES_FAILURE:
            return {
                ...state,
                loadingActivities: false,
                activitiesError: action.error,
            };

        default:
            return state;
    }
};
